// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__2MpC6","grow0":"Button_grow0__27Hgv","grow1":"Button_grow1__27O31"};